import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgFiHome({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 17"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.5894 1.30645C7.83014 1.11921 8.16725 1.11921 8.40799 1.30645L14.408 5.97311C14.5704 6.09942 14.6654 6.29362 14.6654 6.49935V13.8327C14.6654 14.3631 14.4547 14.8718 14.0796 15.2469C13.7045 15.622 13.1958 15.8327 12.6654 15.8327H3.33203C2.8016 15.8327 2.29289 15.622 1.91782 15.2469C1.54274 14.8718 1.33203 14.3631 1.33203 13.8327V6.49935C1.33203 6.29362 1.42701 6.09942 1.5894 5.97311L7.5894 1.30645ZM2.66536 6.8254V13.8327C2.66536 14.0095 2.7356 14.1791 2.86063 14.3041C2.98565 14.4291 3.15522 14.4993 3.33203 14.4993H12.6654C12.8422 14.4993 13.0117 14.4291 13.1368 14.3041C13.2618 14.1791 13.332 14.0095 13.332 13.8327V6.8254L7.9987 2.67726L2.66536 6.8254Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.33203 8.50065C5.33203 8.13246 5.63051 7.83398 5.9987 7.83398H9.9987C10.3669 7.83398 10.6654 8.13246 10.6654 8.50065V15.1673C10.6654 15.5355 10.3669 15.834 9.9987 15.834C9.63051 15.834 9.33203 15.5355 9.33203 15.1673V9.16732H6.66536V15.1673C6.66536 15.5355 6.36689 15.834 5.9987 15.834C5.63051 15.834 5.33203 15.5355 5.33203 15.1673V8.50065Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgFiHome;
